import { render, staticRenderFns } from "./EOBExam.vue?vue&type=template&id=67fec579&scoped=true&"
import script from "./EOBExam.vue?vue&type=script&lang=js&"
export * from "./EOBExam.vue?vue&type=script&lang=js&"
import style0 from "./EOBExam.vue?vue&type=style&index=0&id=67fec579&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fec579",
  null
  
)

export default component.exports